import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-ucr-donut',
  templateUrl: './ucr-donut.component.html',
  styleUrls: ['./ucr-donut.component.css']
})
export class UcrDonutComponent implements OnInit,AfterViewInit {

  options: any;
  chart:any;
  @Input() ucrid:any;
  @Input() gameTranscationMetadata:any;
  data = [];

  constructor() {
    this.options = {
      colors: ['#0072bc', '#E5E4E2'],
      title: {
        useHTML: true,
        text:
          `<div class="score-container" style="text-align:center">
        <div class="top" style="display: flex;align-items: center;margin-top:20px">
        <span style="color: #0072bc; font-size: 3vw; font-weight: bold;font-family: sans-serif;"> ` +
          '1' +
          ` </span>
            <div style="display: flex;flex-direction: column;">
                <span style="color: grey;font-size: 1vw;font-weight: bold"> OUT</span>
                <span style="color: grey;font-size: 1vw;font-weight: bold;display: block;margin-top: -5px;"> OF</span>
            </div>
            <span style="color: black; font-size: 3vw; font-weight: bold;font-family: sans-serif;"> 3 </span><br />
        </div>
        <div class="bottom" style="text-align: center;">
            <span style="color: grey;font-size: 1vw;font-weight: bold;display:block;">CHOICES </span><br />
            <span style="color: grey;font-size: 1vw;font-weight: bold;display:block;margin-top:-32px;">TRIED </span>
        </div>
    </div>`,
        align: 'center',
        verticalAlign: 'middle',
        y: 10,
      },
      tooltip: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            distance: -50,
            style: {
              fontWeight: 'bold',
              color: 'white',
            },
          },
          startAngle: 0,
          endAngle: -180,
          center: ['50%', '50%'],
          size: '75%',
          showInLegend: false,
        },
      },
      series: [
        {
          data: [10, 20],
          type: 'pie',
          size: '20%',
          innerSize: '70%',
        },
      ],
    };
  }
  
  ngOnInit() {
    console.log(this.gameTranscationMetadata)
  }

  ngAfterViewInit(): void {
  
    if (this.ucrid == 'scene1') {
      this.data.push(Number(this.gameTranscationMetadata.remainingSceneChoices[0].played_choices));
      this.data.push(Number(this.gameTranscationMetadata.remainingSceneChoices[0].total_choices) - Number(this.gameTranscationMetadata.remainingSceneChoices[0].played_choices));
    }
    if (this.ucrid == 'scene2') {
      this.data.push(Number(this.gameTranscationMetadata.remainingSceneChoices[1].played_choices));
      this.data.push(Number(this.gameTranscationMetadata.remainingSceneChoices[1].total_choices) - Number(this.gameTranscationMetadata.remainingSceneChoices[1].played_choices));
    }

    this.chart = new Chart(this.ucrid, {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: this.data,
            backgroundColor: ['#0072bc',  'white'],
            fill: false,
            borderWidth: 0,
          },
        ],
      },
      options: {
        cutoutPercentage: 70,
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
      },
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/Screens/ucr-donut/ucr-donut.component.ts